import React, { useState, useEffect } from "react";
import {
  View,
  TouchableOpacity,
  Text,
  Alert,
  StyleSheet,
  Modal,
  ScrollView,
  TextInput,
  ActivityIndicator,
  Image,
} from "react-native";

import { useTranslation } from "react-i18next";

import { FontAwesome } from "@expo/vector-icons";

import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import GlobalStyles from "../../../Resources/Styles";

import { observer, Observer } from "mobx-react";

import { Octicons } from "@expo/vector-icons";
import { Ionicons } from "@expo/vector-icons";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";
import { useScreenDimensions, useDevice } from "../../_layout";

import BlackPng from "../../../assets/BlackPng.png";

const StripePaymentFailed = ({ isVisible, onClose, coach }) => {
  const { t } = useTranslation();
  const { screenWidth, screenHeight, ultraWideScreen, screenSize } =
    useScreenDimensions();
  const { isMobile } = useDevice();

  const GoToInvoicePayment = async () => {
    try {
      window.location.assign(
        // "https://billing.stripe.com/p/login/9AQ3fW6andcNgne000"
        coach.invoicePaymentLink
      );
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const GoToStripeClientPortal = async () => {
    try {
      window.location.assign(
        "https://billing.stripe.com/p/login/9AQ3fW6andcNgne000"
        // coach.invoicePaymentLink
      );
    } catch (error) {
      console.error("Error adding document: ", error);
    }
  };

  const [isHovered, setIsHovered] = useState(false);

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={isVisible}
      onRequestClose={() => console.log("E")}
    >
      <View style={GlobalStyles.centeredView}>
        <TouchableOpacity
          onPress={() => console.log("E")}
          style={GlobalStyles.touchableBackground}
        >
          <View />
        </TouchableOpacity>
        <View
          style={{ position: "absolute" }}
          onStartShouldSetResponder={() => false}
        >
          <View
            style={[
              styles.modalView,
              {
                maxHeight: "90%",
                maxWidth: screenSize != "small" ? 340 : "90%",
                alignSelf: "center",
              },
            ]}
          >
            <ScrollView
              style={{ flex: 1, padding: 20 }}
              showsVerticalScrollIndicator={false}
            >
              <View
                style={{
                  width: "100%",
                }}
              >
                {coach.subscriptionStatus === "past_due" && (
                  <Text
                    style={[
                      Fonts.bold16,
                      { marginBottom: 10, textAlign: "center" },
                    ]}
                  >
                    {t("stripePaymentFailedProblemText-string")}
                  </Text>
                )}

                <Text style={{ marginBottom: 10, textAlign: "center" }}>
                  {coach.subscriptionStatus === "past_due"
                    ? t("stripePaymentFailedActiveSub-string")
                    : t("stripePaymentFailedNewSub-string")}
                </Text>
                <TouchableOpacity
                  onPress={GoToInvoicePayment}
                  style={{ marginTop: 10 }}
                  onMouseEnter={() => !isMobile && setIsHovered(true)}
                  onMouseLeave={() => setIsHovered(false)}
                >
                  <View
                    style={{
                      backgroundColor: Colors.bubbleColor,
                      borderRadius: 10,
                      justifyContent: "center",
                      borderColor: Colors.bubbleColor,
                      height: 40,
                      justifyContent: "center",
                      alignItems: "center",
                      opacity: isHovered ? 0.7 : 1,
                    }}
                  >
                    <Text
                      style={{
                        textAlignVertical: "center",
                        textAlign: "center",
                        color: Colors.whiteColor,
                        marginHorizontal: 10,
                      }}
                    >
                      {t("stripePaymentFailedDoPayment-string")}
                    </Text>
                  </View>
                </TouchableOpacity>
                {coach.subscriptionStatus === "past_due" && (
                  <View style={[GlobalStyles.HStack, { marginTop: 16 }]}>
                    <Text style={[Fonts.regular12]}>
                      {t("stripePaymentFailedAuxText-string")}
                    </Text>
                    <Text
                      style={[Fonts.regular12, { color: Colors.bubbleColor }]}
                      onPress={GoToStripeClientPortal}
                    >
                      {t("stripePaymentFailedAccountConfig-string")}
                    </Text>
                  </View>
                )}
              </View>
            </ScrollView>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  modalView: {
    // width: 800,
    // maxHeight: screenHeight * 0.5,
    borderRadius: 18,
    backgroundColor: Colors.whiteColor,
  },
  title: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 20,
  },
  textInputStyle: {
    width: "100%",
    height: 40,
    borderColor: "gray",
    borderWidth: 1,
    marginBottom: 20,
    padding: 10,
    borderRadius: 10,
  },
  saveButtonStyle: {
    backgroundColor: "#2196F3",
    borderRadius: 20,
    padding: 10,
    elevation: 2,
    width: "100%",
    alignItems: "center",
  },
  saveButtonText: {
    color: "white",
    fontSize: 16,
  },
  textInputStyle: {
    // height: 40,
    // marginBottom: 20,
    // marginHorizontal: 10,
    flex: 1,
    paddingHorizontal: 10,
    paddingVertical: 5,
    borderRadius: 12,
    borderWidth: 0,
    fontWeight: "400",
    fontSize: 16,
    // backgroundColor: "red",
  },
  searchBar: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    borderWidth: 0.2,
    borderColor: Colors.grayColor,
    marginBottom: 20,
    borderRadius: 10,
    height: 40,
    backgroundColor: "transparent",
  },
  verticalDivider: {
    width: 1,
    // maxHeight: screenHeight * 0.5,
    backgroundColor: Colors.borderColor,
  },
  horizontalDivider: {
    height: 1,
    // maxHeight: screenHeight * 0.5,
    backgroundColor: Colors.borderColor,
    marginTop: 40,
  },
});

export default StripePaymentFailed;
